import theme from "themes/Theme";

export const commonStyle = {
  titleText: {
    fontSize: "clamp(1.8rem,4vw,2rem)",
    fontWeight: 400,
    color: theme.palette.text.primary,
  },
  inputLabelStyle: {
    fontSize: "clamp(0.7rem,4vw,0.875rem)",
    fontWeight: 400,
    color: theme.palette.primary.main,
    marginTop: "0.5em",
  },
  inputSlotTextStyle: {
    input: {
      sx: {
        fontSize: "0.875rem",
        color: theme.palette.text.primary,
        fontWeight: 400,
      },
    },
  },
  flexColumn: { display: "flex", flexDirection: "column" },
  rightAlignText: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  leftAlignText: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
  },
};
